import { Routes } from '@angular/router';

export const uomRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/uom-list/uom-list.component').then(m => m.UomListComponent)
  },
  {
    path: 'add',
    loadComponent: () => import('./pages/add-uom/add-uom.component').then(m => m.AddUomComponent)
  },
  {
    path: 'edit/:id',
    loadComponent: () => import('./pages/add-uom/add-uom.component').then(m => m.AddUomComponent)
  }
];
